import { Flex, Padding } from 'UI';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Divider } from './Divider';

interface Props {
	currentStep?: number;
	totalSteps?: number;
	backgroundColor?: string;
	color?: string;
	barderRadius?: string;
	withDivider?: boolean;
}

const StyledBar = styled.div<Props>`
	position: relative;
	overflow: hidden;
	width: 100%;
	border-radius: ${({ theme, barderRadius }) => barderRadius ?? theme.borderRadius.xs};

	&:after {
		content: '';
		display: block;
		width: 100%;
		height: 3px;
		background: ${({ theme, color }) => color ?? theme.colors.primaryGradient4};
		transform: scaleX(
			calc(
				(${({ currentStep }) => (currentStep ?? 1) + 1} / ${({ totalSteps }) => totalSteps ?? 2})
			)
		);
		transform-origin: 0 0;
		transition: transform 0.05s ease-out;
	}

	&:before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		display: block;
		width: 100%;
		height: 3px;
		background-color: ${({ theme, backgroundColor }) => backgroundColor ?? theme.colors.bg2};
	}
`;

const Container = styled.div`
	width: 100%;
	position: relative;
`;

export const ProgressBar: FC<Props> = props => {
	const { withDivider = true } = props;
	return (
		<Padding top='xs' bottom='xs'>
			<Flex align='center'>
				<Container>
					<StyledBar {...props} />
					{withDivider && <Divider />}
				</Container>
			</Flex>
		</Padding>
	);
};
